import {Component, OnInit, ViewChild, signal} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {SimplebarAngularComponent, SimplebarAngularModule} from 'simplebar-angular';
import {
  ROLE_APPLICATION_SETTINGS_READ, ROLE_AUDIT_MINIMAL_READ,
  ROLE_AUDIT_READ,
  ROLE_USER_GROUPS_READ,
  ROLE_USERS_READ, ROLE_VTEX_CATALOG_MINIMAL_READ,
  ROLE_VTEX_CATALOG_READ,
  ROLE_VTEX_ORDERS_READ, ROLE_VTEX_SHOP_SELLERS_MIN_READ, ROLE_VTEX_SHOP_SELLERS_READ
} from '../../../core/models/user/user-info.model';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';

interface MenuItem {
  name: string;
  link?: string;
  icon?: string;
  requiredRole?: string[];
  subMenu?: MenuItem[];
}

const MENU_ITEMS: MenuItem[] = [
  {
    name: 'Página inicial',
    link: '/home',
    icon: 'airplay'
  },
  {
    name: 'Pedidos',
    icon: 'shopping-cart',
    requiredRole: [ROLE_VTEX_ORDERS_READ],
    subMenu: [
      {
        name: 'Visualizar pedidos',
        link: '/orders'
      }
    ]
  },
  {
    name: 'Catalogo',
    icon: 'book',
    requiredRole: [ROLE_VTEX_CATALOG_READ],
    subMenu: [
      {
        name: 'Produtos',
        link: '/catalog/products',
      },
      {
        name: 'Inventário',
        link: '/catalog/inventory',
      }
    ]
  },
  // {
  //   name: 'Etiquetagem',
  //   icon: 'tag',
  //   requiredRole: [ROLE_LABELING_READ,ROLE_LABELING_WRITE],
  //   subMenu: [
  //     {
  //       name: 'Ofertas',
  //       link: '/tagging/offers',
  //     },
  //     {
  //       name: 'Campanhas',
  //       link: '/tagging/campaigns',
  //     },
  //     {
  //       name: 'Campanhas promocionais',
  //       link: '/tagging/promotional-campaigns',
  //     }
  //   ]
  // },
  {
    name: 'Validador de produtos',
    icon: 'book',
    requiredRole: [ROLE_VTEX_CATALOG_MINIMAL_READ],
    subMenu: [
      {
        name: 'Lista',
        link: '/catalog/products',
      }
    ]
  },
  {
    name: 'Vendedores',
    icon: 'users',
    requiredRole: [ROLE_VTEX_SHOP_SELLERS_READ, ROLE_VTEX_SHOP_SELLERS_MIN_READ],
    subMenu: [
      {
        name: 'Vendedores',
        link: '/shop-sellers',
        requiredRole: [ROLE_VTEX_SHOP_SELLERS_READ],
      },
      {
        name: 'Lotes de vendedores',
        link: '/batch-shop-sellers',
        requiredRole: [ROLE_VTEX_SHOP_SELLERS_READ],
      },
      {
        name: 'Lista',
        link: '/shop-sellers-minimal',
        requiredRole: [ROLE_VTEX_SHOP_SELLERS_MIN_READ],
      }
    ]
  },
  {
    name: 'Auditoria',
    icon: 'activity',
    requiredRole: [ROLE_AUDIT_READ, ROLE_AUDIT_MINIMAL_READ],
    subMenu: [
      {
        name: 'Log de atividades',
        link: '/audit/events',
      },
    ]
  },
  {
    name: 'Usuários',
    icon: 'users',
    requiredRole: [ROLE_USERS_READ],
    subMenu: [
      {
        name: 'Usuários',
        link: '/users',
      },
      {
        name: 'Funções',
        link: '/users/roles',
      },
      {
        name: 'Grupos',
        link: '/users/groups',
        requiredRole: [ROLE_USER_GROUPS_READ],
      }
    ]
  },
  {
    name: 'Sistema',
    icon: 'settings',
    requiredRole: [ROLE_APPLICATION_SETTINGS_READ],
    subMenu: [
      {
        name: 'Variáveis de sistema',
        link: '/system/application-settings',
        requiredRole: [ROLE_APPLICATION_SETTINGS_READ],
      }
    ]
  }
];

@Component({
  selector: 'app-layout-sidebar',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    SimplebarAngularModule
  ],
  templateUrl: './layout-sidebar.component.html',
  styleUrl: './layout-sidebar.component.scss'
})
export class LayoutSidebarComponent implements OnInit {

  menuItems = MENU_ITEMS;

  menu = signal<string>('');
  subMenu = signal<string>('');

  currentMenuItems = signal<MenuItem[]>([]);

  @ViewChild('sidebar') sidebar!: SimplebarAngularComponent;

  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService
  ) {
    this.menu.set(this.router.url);
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    this.currentMenuItems.set(this.getMenuItems());
  }

  openMenu(e: any, item: any) {
    e.preventDefault();

    if (this.subMenu() === item) {
      this.subMenu.set('');
    } else {
      this.subMenu.set(item);
    }

    setTimeout(() => {
      if (this.sidebar?.SimpleBar) {
        this.sidebar.SimpleBar.recalculate();
      }
    }, 300);
  }

  getMenuItems(): MenuItem[] {
    const result: MenuItem[] = [];
    for (const menuItem of this.menuItems) {
      const item = this.getMenuItem(menuItem);
      if (item) {
        result.push(item);
      } else {
      }
    }
    return result;
  }

  private getMenuItem(item: MenuItem): MenuItem | undefined {
    if (item.requiredRole && item.requiredRole.length > 0) {
      if (!this.authenticationService.hasAnyRole(item.requiredRole)) {
        return undefined;
      }
    }

    const menuItem: Partial<MenuItem> = {
      name: item.name,
      link: item.link,
      icon: item.icon,
      requiredRole: item.requiredRole,
    };
    if (item.subMenu && item.subMenu.length > 0) {
      menuItem.subMenu = [];
      for (const subMenuItem of item.subMenu) {
        const subMenuNewItem = this.getMenuItem(subMenuItem);
        if (subMenuNewItem) {
          menuItem.subMenu.push(subMenuNewItem);
        }
      }
    }
    return <MenuItem>menuItem;
  }

  getMenuItemNames(menuItem: MenuItem): string[] {
    if (!menuItem?.subMenu) {
      return [];
    }
    return menuItem.subMenu.map(y => y.link ?? '#');
  }
}
